// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cabin:ital,wght@0,400..700;1,400..700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-16 {
  bottom: 4rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.left-0 {
  left: 0px;
}
.left-12 {
  left: 3rem;
}
.left-\\[300px\\] {
  left: 300px;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.right-0 {
  right: 0px;
}
.right-12 {
  right: 3rem;
}
.right-4 {
  right: 1rem;
}
.right-\\[-32px\\] {
  right: -32px;
}
.right-\\[-8px\\] {
  right: -8px;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-\\[-4px\\] {
  top: -4px;
}
.top-\\[-8px\\] {
  top: -8px;
}
.top-\\[10px\\] {
  top: 10px;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-50 {
  z-index: 50;
}
.m-0 {
  margin: 0px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-\\[100px\\] {
  margin-bottom: 100px;
}
.mb-\\[80px\\] {
  margin-bottom: 80px;
}
.mb-s-20 {
  margin-bottom: 20px;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-8 {
  margin-left: 2rem;
}
.mr-0 {
  margin-right: 0px;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-s-30 {
  margin-right: 30px;
}
.ms-1 {
  margin-inline-start: 0.25rem;
}
.ms-2 {
  margin-inline-start: 0.5rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[1\\.8rem\\] {
  margin-top: 1.8rem;
}
.mt-\\[100px\\] {
  margin-top: 100px;
}
.mt-\\[2px\\] {
  margin-top: 2px;
}
.mt-\\[40px\\] {
  margin-top: 40px;
}
.mt-\\[60px\\] {
  margin-top: 60px;
}
.mt-\\[6px\\] {
  margin-top: 6px;
}
.mt-\\[80px\\] {
  margin-top: 80px;
}
.mt-s-10 {
  margin-top: 10px;
}
.box-border {
  box-sizing: border-box;
}
.\\!block {
  display: block !important;
}
.block {
  display: block;
}
.\\!flex {
  display: flex !important;
}
.flex {
  display: flex;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.\\!h-\\[40px\\] {
  height: 40px !important;
}
.\\!h-full {
  height: 100% !important;
}
.\\!h-s-40 {
  height: 40px !important;
}
.h-10 {
  height: 2.5rem;
}
.h-6 {
  height: 1.5rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[100vh\\] {
  height: 100vh;
}
.h-\\[240px\\] {
  height: 240px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[280px\\] {
  height: 280px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[44px\\] {
  height: 44px;
}
.h-\\[468px\\] {
  height: 468px;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[500px\\] {
  height: 500px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[520px\\] {
  height: 520px;
}
.h-\\[56px\\] {
  height: 56px;
}
.h-\\[648px\\] {
  height: 648px;
}
.h-\\[64px\\] {
  height: 64px;
}
.h-\\[680px\\] {
  height: 680px;
}
.h-\\[72px\\] {
  height: 72px;
}
.h-\\[calc\\(100\\%_-_240px\\)\\] {
  height: calc(100% - 240px);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-input-sm {
  height: 48px;
}
.h-s-40 {
  height: 40px;
}
.h-screen {
  height: 100vh;
}
.min-h-\\[100vh\\] {
  min-height: 100vh;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-\\[40px\\] {
  width: 40px !important;
}
.\\!w-full {
  width: 100% !important;
}
.\\!w-s-40 {
  width: 40px !important;
}
.w-0 {
  width: 0px;
}
.w-10 {
  width: 2.5rem;
}
.w-6 {
  width: 1.5rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[100vw\\] {
  width: 100vw;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[142px\\] {
  width: 142px;
}
.w-\\[160px\\] {
  width: 160px;
}
.w-\\[170px\\] {
  width: 170px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[212px\\] {
  width: 212px;
}
.w-\\[230px\\] {
  width: 230px;
}
.w-\\[24px\\] {
  width: 24px;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[26px\\] {
  width: 26px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[320px\\] {
  width: 320px;
}
.w-\\[380px\\] {
  width: 380px;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[48px\\] {
  width: 48px;
}
.w-\\[50px\\] {
  width: 50px;
}
.w-\\[60\\%\\] {
  width: 60%;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[800px\\] {
  width: 800px;
}
.w-\\[900px\\] {
  width: 900px;
}
.w-\\[956px\\] {
  width: 956px;
}
.w-\\[calc\\(100\\%_-_300px\\)\\] {
  width: calc(100% - 300px);
}
.w-full {
  width: 100%;
}
.w-s-20 {
  width: 20px;
}
.w-s-40 {
  width: 40px;
}
.w-s-60 {
  width: 60px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[320px\\] {
  min-width: 320px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[372px\\] {
  max-width: 372px;
}
.max-w-\\[420px\\] {
  max-width: 420px;
}
.max-w-\\[460px\\] {
  max-width: 460px;
}
.max-w-\\[700px\\] {
  max-width: 700px;
}
.max-w-\\[900px\\] {
  max-width: 900px;
}
.max-w-\\[956px\\] {
  max-width: 956px;
}
.flex-1 {
  flex: 1 1;
}
.\\!border-spacing-1 {
  --tw-border-spacing-x: 0.25rem !important;
  --tw-border-spacing-y: 0.25rem !important;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y) !important;
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[0\\] {
  --tw-rotate: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[180deg\\] {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.resize-none {
  resize: none;
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.\\!items-center {
  align-items: center !important;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-lg {
  border-radius: 0.5rem !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[12px\\] {
  border-radius: 12px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-bl-3xl {
  border-bottom-left-radius: 1.5rem;
}
.rounded-br-3xl {
  border-bottom-right-radius: 1.5rem;
}
.rounded-tl-3xl {
  border-top-left-radius: 1.5rem;
}
.rounded-tl-sm {
  border-top-left-radius: 0.125rem;
}
.rounded-tr-3xl {
  border-top-right-radius: 1.5rem;
}
.rounded-tr-sm {
  border-top-right-radius: 0.125rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.\\!border-none {
  border-style: none !important;
}
.border-none {
  border-style: none;
}
.\\!border-\\[white\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-pink-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(236 72 153 / var(--tw-border-opacity, 1)) !important;
}
.border-base-color {
  border-color: rgba(255, 108, 125, 1);
}
.border-pink-theme-1 {
  border-color: rgba(255, 108, 125, 1);
}
.border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.\\!bg-\\[\\#6d32a8\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(109 50 168 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#f2f1f4\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(242 241 244 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-green-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-orange-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.bg-\\[\\#f2f1f4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 241 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f47680\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 118 128 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4768D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 118 141 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6f6f6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8b0251c\\] {
  background-color: #f8b0251c;
}
.bg-\\[\\#ff6c7d1a\\] {
  background-color: #ff6c7d1a;
}
.bg-\\[\\#fff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffffff70\\] {
  background-color: #ffffff70;
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-3 {
  --tw-bg-opacity: 1;
  background-color: rgb(206 206 206 / var(--tw-bg-opacity, 1));
}
.bg-gray-4 {
  --tw-bg-opacity: 1;
  background-color: rgb(247 246 249 / var(--tw-bg-opacity, 1));
}
.bg-main-theme {
  background-color: rgba(255, 108, 125, 1);
}
.bg-pink-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.\\!bg-none {
  background-image: none !important;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.\\!px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[0px\\] {
  padding-left: 0px;
  padding-right: 0px;
}
.px-\\[156px\\] {
  padding-left: 156px;
  padding-right: 156px;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pe-1 {
  padding-inline-end: 0.25rem;
}
.pe-4 {
  padding-inline-end: 1rem;
}
.pe-8 {
  padding-inline-end: 2rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-16 {
  padding-right: 4rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.ps-4 {
  padding-inline-start: 1rem;
}
.ps-\\[348px\\] {
  padding-inline-start: 348px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-\\[16px\\] {
  padding-top: 16px;
}
.pt-\\[92px\\] {
  padding-top: 92px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.font-cabin {
  font-family: Cabin,  sans-serif;
}
.font-rale-way {
  font-family: Raleway, sans-serif;
}
.font-roboto {
  font-family: Roboto, sans-serif;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[1\\.4rem\\] {
  font-size: 1.4rem;
}
.text-\\[120px\\] {
  font-size: 120px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[19px\\] {
  font-size: 19px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[25px\\] {
  font-size: 25px;
}
.text-\\[26px\\] {
  font-size: 26px;
}
.text-\\[27px\\] {
  font-size: 27px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[36px\\] {
  font-size: 36px;
}
.text-\\[60px\\] {
  font-size: 60px;
}
.text-\\[8px\\] {
  font-size: 8px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-h4 {
  font-size: 40px;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.\\!font-\\[600\\] {
  font-weight: 600 !important;
}
.font-\\[400\\] {
  font-weight: 400;
}
.font-\\[600\\] {
  font-weight: 600;
}
.font-\\[700\\] {
  font-weight: 700;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-\\[12px\\] {
  line-height: 12px;
}
.leading-\\[24px\\] {
  line-height: 24px;
}
.leading-\\[40px\\] {
  line-height: 40px;
}
.leading-\\[48px\\] {
  line-height: 48px;
}
.leading-tight {
  line-height: 1.25;
}
.\\!text-\\[\\#000080\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 128 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-gray-1 {
  --tw-text-opacity: 1 !important;
  color: rgb(100 100 100 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-pink-theme-1 {
  color: rgba(255, 108, 125, 1) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#242424\\] {
  --tw-text-opacity: 1;
  color: rgb(36 36 36 / var(--tw-text-opacity, 1));
}
.text-\\[\\#262626\\] {
  --tw-text-opacity: 1;
  color: rgb(38 38 38 / var(--tw-text-opacity, 1));
}
.text-\\[\\#545454\\] {
  --tw-text-opacity: 1;
  color: rgb(84 84 84 / var(--tw-text-opacity, 1));
}
.text-\\[\\#636363\\] {
  --tw-text-opacity: 1;
  color: rgb(99 99 99 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8c8c8c\\] {
  --tw-text-opacity: 1;
  color: rgb(140 140 140 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f2f1f4\\] {
  --tw-text-opacity: 1;
  color: rgb(242 241 244 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f8b025a6\\] {
  color: #f8b025a6;
}
.text-\\[\\#fa454d\\] {
  --tw-text-opacity: 1;
  color: rgb(250 69 77 / var(--tw-text-opacity, 1));
}
.text-\\[\\#fa5863\\] {
  --tw-text-opacity: 1;
  color: rgb(250 88 99 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ffeded\\] {
  --tw-text-opacity: 1;
  color: rgb(255 237 237 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-gray-1 {
  --tw-text-opacity: 1;
  color: rgb(100 100 100 / var(--tw-text-opacity, 1));
}
.text-gray-2 {
  --tw-text-opacity: 1;
  color: rgb(140 140 140 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-light-dark {
  --tw-text-opacity: 1;
  color: rgb(83 83 84 / var(--tw-text-opacity, 1));
}
.text-orange-400 {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.text-pink-theme-1 {
  color: rgba(255, 108, 125, 1);
}
.text-secondary {
  color: rgba(0, 0, 0, 0.88);
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.placeholder-black\\/50::placeholder {
  color: rgb(0 0 0 / 0.5);
}
.\\!shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-primary {
  --tw-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  --tw-shadow-colored: 0px 7px 29px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\!outline-none {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-100 {
  transition-delay: 100ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

body {
  margin: 0;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  /* user-select: none; */
  /* user-zoom: none; */
  color: black;
} 

* {
  box-sizing: border-box;
}

body,
html {
  /* position: fixed; */
}

input,
textarea,
button,
select,
a {
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}

a, b, body, div, h1, h2, h3, h4, h5, h6, html, img, p, q, s, span {
  font-size: 100%;
  font: inherit;
  margin: 0;
  padding: 0;
  vertical-align: initial;
}

.gradient-theme-secondary {
  background: linear-gradient(90deg, #fef6ad, #feaaf8);
}

.gradient-theme {
  background: linear-gradient(110.01deg, #FFECB8 0.41%, #FFB6EC 123.48%);
}

.gradient-blur {
  background: linear-gradient(110.01deg, rgba(0,0,0,0) 52%, #FFB6EC 123.48%);
}

.overlay-gray {
  background: #fff3;
}


/* custom antd */

/* antd input */
.ant-input-wrapper {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 100%;
  border-radius: 12px !important;
  /* border: 1px solid #ffffff !important; */
  box-shadow: none !important;
}

.large-rounded .ant-select-selector {
  border-radius: 12px !important;
}

.small-rounded .ant-select-selector {
  border-radius: 8px !important;
}

.ant-form-item-explain {
  margin-bottom: 12px;
}

::placeholder {
  color: rgba(151, 151, 151, 1);
  opacity: 1; /* Firefox */
}

::-ms-input-placeholder { /* Edge 12 -18 */
  color: rgba(151, 151, 151, 1);
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(194, 194, 194, 0.3);
  border-radius: 10px;
  background-color: transparent;
  height: 10px;
}

::-webkit-scrollbar {
  width: 4px;
  height: 6px;
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(202, 202, 202, 0.3);
  background-color: #c7c7c7;
  height: 10px;
}

/* raw text */
.bot-message-content p {
  margin-top: 4px;
  margin-bottom: 0px;
}
.bot-message-content ul {
  margin: 0;
  margin-block-start: 0px !important;
  margin-block-end: 0px !important;
}
.bot-message-content li {
  line-height: 20px !important;
}


/* typing dot */
.typing-dot {
  height: 8px;
  width: 8px;
  border-radius: 100%;
  margin-left: 4px;
  display: inline-block;
  background: linear-gradient(90deg, rgba(255, 108, 125, 1) 2.61%, rgba(255, 108, 125, 1) 52.73%, rgba(255, 108, 125, 1) 100%);
  animation: 1.4s typing-dot ease-in-out infinite;
}
.typing-dot:nth-of-type(2) {
  animation-delay: 0.15s;
}
.typing-dot:nth-of-type(3) {
  animation-delay: 0.25s;
}
@keyframes typing-dot {
  15% {
      transform: translateY(-35%);
      opacity: 0.5;
  }
  30% {
      transform: translateY(0%);
      opacity: 1;
  }
}

/* custom react phone input 2 */
.react-tel-input .special-label {
  display: none !important;
  /* border: rgba(255, 108, 125, 1) !important; */
}

.react-tel-input input {
  /* border-color: white !important; */
}

.ant-form-item-has-error .react-tel-input input {
  border-color: rgba(255, 108, 125, 1) !important;
}

::placeholder {
  color: rgb(189, 189, 189) !important;
  opacity: 1 !important; /* Firefox */
  font-size: 1rem !important;
}

.ant-select-selection-placeholder {
  font-size: 1rem !important;
}


.conversation-more {
  background: rgb(0,0,0);
  background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(255,245,245,1) 33%, rgba(255,255,255,0.9780287114845938) 100%);
}

.overflow-anchor-none {
  overflow-anchor: none;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes spin-words {
  20% {
    transform: translateZ(0);
  }
  22% {
    transform: translateY(10%);
  } 
  30% {
    transform: translateY(-110%);
  }
  35% {
    transform: translateY(-100%);
  }
  45% {
    transform: translateY(-210%);
  }
  50% {
    transform: translateY(-200%);
  }
  60% {
    transform: translateY(-310%);
  }
  65% {
    transform: translateY(-300%);
  }
  75% {
    transform: translateY(-410%);
  }
  80% {
    transform: translateY(-400%);
  }
  100% {
    transform: translateY(-400%);
  }
}

.spin-words-animation {
  animation: spin-words 10s infinite;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}

.ant-modal-mask {
  z-index: 1200  !important;
  background-color: rgba(0, 0, 0, 0.8);
}

.ant-modal-wrap {
  z-index: 1205 !important;
}

.ant-btn {
  display: inline-block;
}

.ant-picker-input input {
  font-size: 14px !important;
}

.ant-input-outlined {
  font-size: 14px;
}

.ant-input-outlined[disabled] {
  color: black;
  background-color: rgba(255, 255, 255, 0.356);
}

.ant-select-selector span {
  font-size: 14px;
}

.ant-select-disabled {
  background-color: rgba(255, 255, 255, 0.356) !important;
}

.ant-select-disabled span {
  color: black !important;
}

.ant-picker-disabled  {
  background-color: rgba(255, 255, 255, 0.356) !important;
}

.ant-picker-input input { 
  font-size: 14px;
}

.ant-picker-disabled span, .ant-picker-disabled .ant-picker-input input {
  color: black !important;
}

.custom-phone-input-disabled input {
  background-color: rgba(255, 255, 255, 0.356) !important;
}

/* pagination */

.ant-pagination {
  margin-top: 2rem !important;
}

.ant-pagination-item-active {
  background-color: rgba(255, 108, 125, 1) !important;
  border-color: rgba(255, 108, 125, 1) !important;
}

.ant-pagination-item-active a {
  color: white !important;
}

.ant-modal-title {
  font-size: 1.4rem !important;
  font-family: "Raleway", serif;
  padding-bottom: 2rem;
}

.ant-table-expanded-row {
  background-color: #F7F6F9;
}

/* TABS */

.ant-tabs-tab-btn {
  color: rgba(34, 34, 34, 1) !important;
}

.ant-tabs-tab-active .ant-tabs-tab-btn {
  font-weight: bold;
}

.ant-tabs-tab.ant-tabs-tab-disabled {
  color: var(--disabled-color);
}

.hover\\:cursor-pointer:hover {
  cursor: pointer;
}

.hover\\:bg-\\[\\#000000\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#0077b5\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 119 181 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#0866ff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(8 102 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#ff4500\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 69 0 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-4:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(247 246 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:\\!text-black:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-\\[white\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.hover\\:text-pink-theme-1:hover {
  color: rgba(255, 108, 125, 1);
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-0:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

@media not all and (min-width: 1280px) {

  .max-xl\\:right-4 {
    right: 1rem;
  }

  .max-xl\\:block {
    display: block;
  }

  .max-xl\\:flex {
    display: flex;
  }

  .max-xl\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .max-xl\\:w-\\[320px\\] {
    width: 320px;
  }

  .max-xl\\:w-\\[700px\\] {
    width: 700px;
  }

  .max-xl\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .max-xl\\:ps-\\[348px\\] {
    padding-inline-start: 348px;
  }
}

@media not all and (min-width: 1024px) {

  .max-lg\\:right-\\[-8px\\] {
    right: -8px;
  }

  .max-lg\\:top-\\[-8px\\] {
    top: -8px;
  }

  .max-lg\\:block {
    display: block;
  }

  .max-lg\\:hidden {
    display: none;
  }

  .max-lg\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .max-lg\\:w-\\[60px\\] {
    width: 60px;
  }

  .max-lg\\:w-\\[700px\\] {
    width: 700px;
  }

  .max-lg\\:max-w-\\[auto\\] {
    max-width: auto;
  }

  .max-lg\\:flex-col {
    flex-direction: column;
  }

  .max-lg\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .max-lg\\:ps-\\[84px\\] {
    padding-inline-start: 84px;
  }

  .max-lg\\:text-center {
    text-align: center;
  }

  .max-lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}

@media not all and (min-width: 768px) {

  .max-md\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .max-md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media not all and (min-width: 640px) {

  .max-sm\\:right-4 {
    right: 1rem;
  }

  .max-sm\\:top-\\[10px\\] {
    top: 10px;
  }

  .max-sm\\:block {
    display: block;
  }

  .max-sm\\:hidden {
    display: none;
  }

  .max-sm\\:h-\\[calc\\(100vh-128px\\)\\] {
    height: calc(100vh - 128px);
  }

  .max-sm\\:h-\\[calc\\(100vh-300px\\)\\] {
    height: calc(100vh - 300px);
  }

  .max-sm\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .max-sm\\:flex-col {
    flex-direction: column;
  }

  .max-sm\\:rounded-none {
    border-radius: 0px;
  }

  .max-sm\\:bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }

  .max-sm\\:p-4 {
    padding: 1rem;
  }

  .max-sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .max-sm\\:pb-0 {
    padding-bottom: 0px;
  }

  .max-sm\\:pl-11 {
    padding-left: 2.75rem;
  }

  .max-sm\\:pr-0 {
    padding-right: 0px;
  }

  .max-sm\\:pr-11 {
    padding-right: 2.75rem;
  }

  .max-sm\\:pr-6 {
    padding-right: 1.5rem;
  }

  .max-sm\\:ps-0 {
    padding-inline-start: 0px;
  }

  .max-sm\\:ps-6 {
    padding-inline-start: 1.5rem;
  }

  .max-sm\\:pt-8 {
    padding-top: 2rem;
  }

  .max-sm\\:pt-\\[64px\\] {
    padding-top: 64px;
  }

  .max-sm\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .max-sm\\:shadow-none {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (min-width: 640px) {

  .sm\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .sm\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .sm\\:mb-s-20 {
    margin-bottom: 20px;
  }

  .sm\\:mt-s-10 {
    margin-top: 10px;
  }

  .sm\\:h-input-sm {
    height: 48px;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  @media not all and (min-width: 768px) {

    .sm\\:max-md\\:block {
      display: block;
    }

    .sm\\:max-md\\:flex {
      display: flex;
    }

    .sm\\:max-md\\:justify-between {
      justify-content: space-between;
    }

    .sm\\:max-md\\:px-2 {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }
}

@media (min-width: 768px) {

  .md\\:left-0 {
    left: 0px;
  }

  .md\\:mx-8 {
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .md\\:mb-s-30 {
    margin-bottom: 30px;
  }

  .md\\:mt-s-20 {
    margin-top: 20px;
  }

  .md\\:h-input {
    height: 54px;
  }

  .md\\:w-\\[280px\\] {
    width: 280px;
  }

  .md\\:w-\\[600px\\] {
    width: 600px;
  }

  .md\\:translate-x-\\[0\\] {
    --tw-translate-x: 0;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-0 {
    gap: 0px;
  }

  .md\\:rounded-2xl {
    border-radius: 1rem;
  }

  .md\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:px-\\[156px\\] {
    padding-left: 156px;
    padding-right: 156px;
  }

  .md\\:py-3\\.5 {
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }

  .md\\:pl-4 {
    padding-left: 1rem;
  }

  .md\\:pr-12 {
    padding-right: 3rem;
  }

  .md\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .md\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .md\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .md\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .md\\:text-\\[48px\\] {
    font-size: 48px;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

@media (min-width: 1024px) {

  .lg\\:mr-8 {
    margin-right: 2rem;
  }

  .lg\\:mt-12 {
    margin-top: 3rem;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:w-\\[800px\\] {
    width: 800px;
  }

  .lg\\:w-\\[956px\\] {
    width: 956px;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .lg\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .lg\\:text-\\[48px\\] {
    font-size: 48px;
  }

  .lg\\:text-\\[60px\\] {
    font-size: 60px;
  }
}

@media (min-width: 1280px) {

  .xl\\:block {
    display: block;
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:text-left {
    text-align: left;
  }
}

@media (prefers-color-scheme: dark) {

  .dark\\:bg-transparent {
    background-color: transparent;
  }

  .dark\\:placeholder-white\\/50::placeholder {
    color: rgb(255 255 255 / 0.5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAKnB;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;;EAKE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,iBAAiB;AACnB;;;AAGA,gBAAgB;;AAEhB,eAAe;AACf;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,UAAU,EAAE,YAAY;AAC1B;;AAEA,0BAA0B,gBAAgB;EACxC,6BAA6B;AAC/B;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,0DAA0D;EAC1D,yBAAyB;EACzB,YAAY;AACd;;AAEA,aAAa;AACb;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,kCAAkC;EAClC,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;;;AAGA,eAAe;AACf;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,4HAA4H;EAC5H,+CAA+C;AACjD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE;MACI,2BAA2B;MAC3B,YAAY;EAChB;EACA;MACI,yBAAyB;MACzB,UAAU;EACd;AACF;;AAEA,+BAA+B;AAC/B;EACE,wBAAwB;EACxB,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,qBAAqB,EAAE,YAAY;EACnC,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,sBAAsB;EACtB,wHAAwH;AAC1H;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uDAAuD;AACzD;;AAEA,eAAe;;AAEf;EACE,2BAA2B;AAC7B;;AAEA;EACE,mDAAmD;EACnD,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,SAAS;;AAET;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AA7UA;EAAA;AA8UA;;AA9UA;EAAA,kBA8UA;EA9UA;AA8UA;;AA9UA;EAAA,kBA8UA;EA9UA;AA8UA;;AA9UA;EAAA,kBA8UA;EA9UA;AA8UA;;AA9UA;EAAA,kBA8UA;EA9UA;AA8UA;;AA9UA;EAAA,kBA8UA;EA9UA;AA8UA;;AA9UA;EAAA,kBA8UA;EA9UA;AA8UA;;AA9UA;EAAA,+BA8UA;EA9UA;AA8UA;;AA9UA;EAAA,oBA8UA;EA9UA;AA8UA;;AA9UA;EAAA,oBA8UA;EA9UA;AA8UA;;AA9UA;EAAA;AA8UA;;AA9UA;EAAA;AA8UA;;AA9UA;EAAA,2GA8UA;EA9UA,yGA8UA;EA9UA;AA8UA;;AA9UA;EAAA,2GA8UA;EA9UA,yGA8UA;EA9UA;AA8UA;;AA9UA;;EAAA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA,kBA8UA;IA9UA;EA8UA;;EA9UA;IAAA;EA8UA;AAAA;;AA9UA;;EAAA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA,oBA8UA;IA9UA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA,mBA8UA;IA9UA;EA8UA;AAAA;;AA9UA;;EAAA;IAAA;EA8UA;;EA9UA;IAAA,kBA8UA;IA9UA;EA8UA;AAAA;;AA9UA;;EAAA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA,kBA8UA;IA9UA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA,oBA8UA;IA9UA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA,sBA8UA;IA9UA,8BA8UA;IA9UA;EA8UA;AAAA;;AA9UA;;EAAA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;;IAAA;MAAA;IA8UA;;IA9UA;MAAA;IA8UA;;IA9UA;MAAA;IA8UA;;IA9UA;MAAA,oBA8UA;MA9UA;IA8UA;EAAA;AAAA;;AA9UA;;EAAA;IAAA;EA8UA;;EA9UA;IAAA,iBA8UA;IA9UA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA,mBA8UA;IA9UA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA,mBA8UA;IA9UA;EA8UA;;EA9UA;IAAA,qBA8UA;IA9UA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA,eA8UA;IA9UA;EA8UA;AAAA;;AA9UA;;EAAA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA,kBA8UA;IA9UA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;AAAA;;AA9UA;;EAAA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;AAAA;;AA9UA;;EAAA;IAAA;EA8UA;;EA9UA;IAAA;EA8UA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Cabin:ital,wght@0,400..700;1,400..700&display=swap');\n\nbody {\n  margin: 0;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 14px;\n  /* user-select: none; */\n  /* user-zoom: none; */\n  color: black;\n} \n\n* {\n  box-sizing: border-box;\n}\n\nbody,\nhtml {\n  /* position: fixed; */\n}\n\ninput,\ntextarea,\nbutton,\nselect,\na {\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n}\n\na, b, body, div, h1, h2, h3, h4, h5, h6, html, img, p, q, s, span {\n  font-size: 100%;\n  font: inherit;\n  margin: 0;\n  padding: 0;\n  vertical-align: initial;\n}\n\n.gradient-theme-secondary {\n  background: linear-gradient(90deg, #fef6ad, #feaaf8);\n}\n\n.gradient-theme {\n  background: linear-gradient(110.01deg, #FFECB8 0.41%, #FFB6EC 123.48%);\n}\n\n.gradient-blur {\n  background: linear-gradient(110.01deg, rgba(0,0,0,0) 52%, #FFB6EC 123.48%);\n}\n\n.overlay-gray {\n  background: #fff3;\n}\n\n\n/* custom antd */\n\n/* antd input */\n.ant-input-wrapper {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  width: 100%;\n  border-radius: 12px !important;\n  /* border: 1px solid #ffffff !important; */\n  box-shadow: none !important;\n}\n\n.large-rounded .ant-select-selector {\n  border-radius: 12px !important;\n}\n\n.small-rounded .ant-select-selector {\n  border-radius: 8px !important;\n}\n\n.ant-form-item-explain {\n  margin-bottom: 12px;\n}\n\n::placeholder {\n  color: rgba(151, 151, 151, 1);\n  opacity: 1; /* Firefox */\n}\n\n::-ms-input-placeholder { /* Edge 12 -18 */\n  color: rgba(151, 151, 151, 1);\n}\n\n::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(194, 194, 194, 0.3);\n  border-radius: 10px;\n  background-color: transparent;\n  height: 10px;\n}\n\n::-webkit-scrollbar {\n  width: 4px;\n  height: 6px;\n  background-color: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(202, 202, 202, 0.3);\n  background-color: #c7c7c7;\n  height: 10px;\n}\n\n/* raw text */\n.bot-message-content p {\n  margin-top: 4px;\n  margin-bottom: 0px;\n}\n.bot-message-content ul {\n  margin: 0;\n  margin-block-start: 0px !important;\n  margin-block-end: 0px !important;\n}\n.bot-message-content li {\n  line-height: 20px !important;\n}\n\n\n/* typing dot */\n.typing-dot {\n  height: 8px;\n  width: 8px;\n  border-radius: 100%;\n  margin-left: 4px;\n  display: inline-block;\n  background: linear-gradient(90deg, rgba(255, 108, 125, 1) 2.61%, rgba(255, 108, 125, 1) 52.73%, rgba(255, 108, 125, 1) 100%);\n  animation: 1.4s typing-dot ease-in-out infinite;\n}\n.typing-dot:nth-of-type(2) {\n  animation-delay: 0.15s;\n}\n.typing-dot:nth-of-type(3) {\n  animation-delay: 0.25s;\n}\n@keyframes typing-dot {\n  15% {\n      transform: translateY(-35%);\n      opacity: 0.5;\n  }\n  30% {\n      transform: translateY(0%);\n      opacity: 1;\n  }\n}\n\n/* custom react phone input 2 */\n.react-tel-input .special-label {\n  display: none !important;\n  /* border: rgba(255, 108, 125, 1) !important; */\n}\n\n.react-tel-input input {\n  /* border-color: white !important; */\n}\n\n.ant-form-item-has-error .react-tel-input input {\n  border-color: rgba(255, 108, 125, 1) !important;\n}\n\n::placeholder {\n  color: rgb(189, 189, 189) !important;\n  opacity: 1 !important; /* Firefox */\n  font-size: 1rem !important;\n}\n\n.ant-select-selection-placeholder {\n  font-size: 1rem !important;\n}\n\n\n.conversation-more {\n  background: rgb(0,0,0);\n  background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(255,245,245,1) 33%, rgba(255,255,255,0.9780287114845938) 100%);\n}\n\n.overflow-anchor-none {\n  overflow-anchor: none;\n}\n\n@keyframes fade-in {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes spin-words {\n  20% {\n    transform: translateZ(0);\n  }\n  22% {\n    transform: translateY(10%);\n  } \n  30% {\n    transform: translateY(-110%);\n  }\n  35% {\n    transform: translateY(-100%);\n  }\n  45% {\n    transform: translateY(-210%);\n  }\n  50% {\n    transform: translateY(-200%);\n  }\n  60% {\n    transform: translateY(-310%);\n  }\n  65% {\n    transform: translateY(-300%);\n  }\n  75% {\n    transform: translateY(-410%);\n  }\n  80% {\n    transform: translateY(-400%);\n  }\n  100% {\n    transform: translateY(-400%);\n  }\n}\n\n.spin-words-animation {\n  animation: spin-words 10s infinite;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n}\n\n.ant-modal-mask {\n  z-index: 1200  !important;\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n.ant-modal-wrap {\n  z-index: 1205 !important;\n}\n\n.ant-btn {\n  display: inline-block;\n}\n\n.ant-picker-input input {\n  font-size: 14px !important;\n}\n\n.ant-input-outlined {\n  font-size: 14px;\n}\n\n.ant-input-outlined[disabled] {\n  color: black;\n  background-color: rgba(255, 255, 255, 0.356);\n}\n\n.ant-select-selector span {\n  font-size: 14px;\n}\n\n.ant-select-disabled {\n  background-color: rgba(255, 255, 255, 0.356) !important;\n}\n\n.ant-select-disabled span {\n  color: black !important;\n}\n\n.ant-picker-disabled  {\n  background-color: rgba(255, 255, 255, 0.356) !important;\n}\n\n.ant-picker-input input { \n  font-size: 14px;\n}\n\n.ant-picker-disabled span, .ant-picker-disabled .ant-picker-input input {\n  color: black !important;\n}\n\n.custom-phone-input-disabled input {\n  background-color: rgba(255, 255, 255, 0.356) !important;\n}\n\n/* pagination */\n\n.ant-pagination {\n  margin-top: 2rem !important;\n}\n\n.ant-pagination-item-active {\n  background-color: rgba(255, 108, 125, 1) !important;\n  border-color: rgba(255, 108, 125, 1) !important;\n}\n\n.ant-pagination-item-active a {\n  color: white !important;\n}\n\n.ant-modal-title {\n  font-size: 1.4rem !important;\n  font-family: \"Raleway\", serif;\n  padding-bottom: 2rem;\n}\n\n.ant-table-expanded-row {\n  background-color: #F7F6F9;\n}\n\n/* TABS */\n\n.ant-tabs-tab-btn {\n  color: rgba(34, 34, 34, 1) !important;\n}\n\n.ant-tabs-tab-active .ant-tabs-tab-btn {\n  font-weight: bold;\n}\n\n.ant-tabs-tab.ant-tabs-tab-disabled {\n  color: var(--disabled-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
